<template>
  <div class="container">
    <div class="range-wrap">
      <range-dialog></range-dialog>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="时间课表" name="time">
        <tab-time
          :cid="classRoomId"
          :tid="teacherId"
          :tname="teacherName"
          :dayViewTime="goTimeDayView"
          :startTime="startTime"
          :endTime="endTime"
          :visible="activeName === 'time'"
        ></tab-time>
      </el-tab-pane>
      <el-tab-pane label="教师课表" name="teacher">
        <tab-teacher :visible="activeName === 'teacher'"></tab-teacher>
      </el-tab-pane>
      <el-tab-pane label="教室课表" name="classroom">
        <tab-classroom
          :id="clId"
          :visible="activeName === 'classroom'"
        ></tab-classroom>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tabTime from "./lessonCalendar/index.vue";
import eventBus from "@/utils/bus";
import tabTeacher from "./teacher.vue";
import tabClassroom from "./classroomCalendar/index.vue";
import rangeDialog from "./rangeDialog.vue";

export default {
  name: "storeSchedule",
  components: {
    tabTime,
    tabTeacher,
    rangeDialog,
    tabClassroom,
  },
  data() {
    return {
      activeName: "classroom",
      classRoomId: "",
      teacherId: "",
      teacherName: "",
      clId: 0,
      curType: "all",
      goTimeDayView: "",
      startTime: "",
      endTime: "",
    };
  },

  created() {
    let pageCache = sessionStorage.getItem("teach-schedule-time-page-cache");
    if (pageCache) {
      let pageCacheJSON = JSON.parse(pageCache);
      if (pageCacheJSON.tab) {
        this.activeName = pageCacheJSON.tab;
      }
    }
  },
  mounted() {
    const cl_Id = this.$route.query.fromClassroomId;
    if (cl_Id) {
      this.clId = Number(cl_Id);
      this.activeName = "classroom";
    }
    eventBus.$on("to-classroom-go-week-view", (obj) => {
      if (obj.cr_id) {
        this.classRoomId = obj.cr_id;
        this.teacherId = "";
      }
      if (obj.day_time) {
        this.startTime = obj.day_time;
        this.endTime = obj.day_time;
      }
      this.activeName = "time";
    });
    eventBus.$on("to-teacher-go-week-view", (obj) => {
      if (obj.t_id) {
        this.teacherId = obj.t_id;
        this.teacherName = obj.t_name;
        this.classRoomId = "";
      }
      this.activeName = "time";
      if (obj.start_time && obj.end_time) {
        this.startTime = obj.start_time;
        this.endTime = obj.end_time;
      }
    });
    eventBus.$on("to-teacher-go-time-day-view", (obj) => {
      if (obj.full) {
        this.classRoomId = "";
        this.teacherId = "";
        this.clId = 0;
        this.goTimeDayView = obj.full;
      }
      this.activeName = "time";
    });
  },
  methods: {
    handleClick() {
      this.classRoomId = "";
      this.teacherId = "";
      this.clId = 0;
      this.goTimeDayView = "";
      this.startTime = "";
      this.endTime = "";
      // if (this.activeName === "time") {
      //   eventBus.$emit("switch-time-tab", 1);
      // }
      sessionStorage.setItem(
        "teach-schedule-time-page-cache",
        JSON.stringify({
          tab: this.activeName,
        })
      );
    },
  },

  beforeDestroy() {
    eventBus.$off("to-classroom-go-week-view");
    eventBus.$off("to-teacher-go-week-view");
    eventBus.$off("to-teacher-go-time-day-view");
    // eventBus.$off("switch-time-tab");
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  .range-wrap {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 998;
  }
}
</style>
